import React from "react";
import "../CardScroller/index.css";

import LottiePlayer from "../LottiePlayer";

type CardPropsType = {
  children?: React.ReactNode;
  card: {
    headerText1: string;
    headerText2: string;
    headerText3: string;
    cardDetails: {
      text1?: string;
      text2: string;
      videoLink?: unknown;
      isDarkBackgroundVideoIcon?: boolean;
      image?: string;
      background: string;
      textColor: string;
      marginBottom?: string;
      lottieClassName?: string;
    }[];
  };
};

const CardIntegration: React.FC<CardPropsType> = ({ card }) => {
  return (
    <div className="pb-8 relative">
      <div className="card-scroller-container p-6">
        <div>
          <h3 className="text-white font-weight-600 gradient-text dashboard-heading-2-gradient pb-2 w-fit-content">
            {card.headerText1}
          </h3>
          <h2 className="cards-shelf-main-header dashboard-heading-2">
            {card.headerText2}&nbsp;
          </h2>
          <span className="cards-shelf-secondary-header dashboard-heading-2">
            {card.headerText3}
          </span>
        </div>
      </div>

      <div className="dp-cards-scroller">
        <div className="dp-cards-scroller-crop">
          <div className="dp-cards-scroller-content">
            <div className="dp-cards-scroller-platter">
              {card.cardDetails.map((detail) => {
                return (
                  <div
                    className="dp-cards-scroller-item-view"
                    key={detail.text1}
                  >
                    <div className="dp-card-width-360">
                      <div
                        className={`dp-card-content ${
                          detail?.background || "bg-white"
                        }`}
                      >
                        <div className="dp-card-img-full-wrapper">
                          <div className="absolute bottom-0 w-full">
                            {detail.videoLink && (
                              <LottiePlayer
                                key={detail.text1}
                                file={detail.videoLink}
                                height={"auto"}
                                width={"100%"}
                                lottieClassName={
                                  detail.lottieClassName || "pb-10"
                                }
                                isDarkBackground={
                                  detail.isDarkBackgroundVideoIcon || false
                                }
                              />
                            )}
                            {detail.image && (
                              <img
                                className={`${detail.marginBottom || "mb-0"}`}
                                alt={detail.text2}
                                key={detail.text1}
                                src={detail.image}
                                height={310}
                                width={360}
                              />
                            )}
                          </div>
                        </div>
                        <div className="dp-card-content-info">
                          <h3 className="dp-card-content-eyebrow">
                            {detail.text1}
                          </h3>
                          <div className="dp-card-content-header">
                            <a
                              className={`dp-card-content-header-link ${
                                detail?.textColor || "text-black"
                              }`}
                            >
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: detail.text2,
                                }}
                              />
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardIntegration;
